import React from 'react';
import { chakra } from '@chakra-ui/react';
export const Svg = ({ children, ...props }) => (<chakra.svg xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    {children}
  </chakra.svg>);
